module.exports = __webpack_public_path__ + "static/media/alpina.a660d984.svg";